import React from "react";
import { useSortedCloseStages } from "@api/organizationCloseStage.api";
import { BaseFilterProps } from "../../lib";
import { SearchableIdListFilter } from "../SearchableIdListFilter/SearchableIdListFilter";

export const TaskStageFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const closeStages = useSortedCloseStages();

    return (
        <SearchableIdListFilter
            items={closeStages}
            selectedIds={filters.taskCloseStageIds}
            onChange={(taskCloseStageIds) => onChange({ taskCloseStageIds })}
            name="taskStage"
        />
    );
};
